import React from "react";
import Navbar from "../../component/Navbar";
import PersonalAndCare from "../../component/solutionscomponent/PersonalAndCare";
import Footer from "../../component/Footer";

const PersonalCare = () => {
  return (
    <>
      <section className="usp_service_section">
        <Navbar />
        <PersonalAndCare />
        <Footer />
      </section>
    </>
  );
};

export default PersonalCare;
